import { render, staticRenderFns } from "./message.vue?vue&type=template&id=52a30fd4"
import script from "./message.js?vue&type=script&lang=js&external"
export * from "./message.js?vue&type=script&lang=js&external"
import style0 from "./message.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports